"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/app/main.ts');
const router_1 = require("@angular/router");
const shared_module_1 = require("../commons/shared.module");
const main_component_1 = require("./main.component");
const global_1 = require("../commons/global");
const profile_component_1 = require("./profile.component");
const root_component_1 = require("../root.component");
const init_guard_1 = require("../init/init.guard");
const contact_component_1 = require("./contact.component");
const ɵ0 = () => Promise.resolve().then(() => require("./jobs/index.ngfactory")).then(m => m.JobsModuleNgFactory), ɵ1 = () => Promise.resolve().then(() => require("./explorer/index.ngfactory")).then(m => m.ExplorerModuleNgFactory), ɵ2 = () => Promise.resolve().then(() => require("./projects/index.ngfactory")).then(m => m.DashboardModuleNgFactory), ɵ3 = () => Promise.resolve().then(() => require("./map/index.ngfactory")).then(m => m.MapModuleNgFactory), ɵ4 = () => Promise.resolve().then(() => require("./settings/index.ngfactory")).then(m => m.SettingsModuleNgFactory);
exports.ɵ0 = ɵ0;
exports.ɵ1 = ɵ1;
exports.ɵ2 = ɵ2;
exports.ɵ3 = ɵ3;
exports.ɵ4 = ɵ4;
const AppRouting = [
    {
        path: '', component: main_component_1.MainComponent, canActivate: [init_guard_1.InitGuard],
        children: [
            { path: '', redirectTo: global_1.AppRoutes.PROJECTS, pathMatch: 'full' },
            { path: global_1.AppRoutes.PROFILE, component: profile_component_1.ProfileComponent, pathMatch: 'full', canActivate: [shared_module_1.AccountNeeded] },
            { path: global_1.AppRoutes.CONTACT, component: contact_component_1.ContactComponent, pathMatch: 'full', canActivate: [shared_module_1.AccountNeeded] },
            { path: global_1.AppRoutes.JOBS, loadChildren: ɵ0, canActivate: [shared_module_1.AccountNeeded] },
            { path: global_1.AppRoutes.EXPLORER, loadChildren: ɵ1, canActivate: [shared_module_1.AccountNeeded] },
            { path: global_1.AppRoutes.PROJECTS, loadChildren: ɵ2, canActivate: [shared_module_1.AccountNeeded] },
            { path: global_1.AppRoutes.INSPECTOR, loadChildren: ɵ3, canActivate: [shared_module_1.AccountNeeded] },
            { path: global_1.AppRoutes.ADMIN, loadChildren: ɵ4, canActivate: [shared_module_1.LoginNeeded] },
            { path: '**', component: root_component_1.NotFoundComponent }
        ]
    }
];
class MainModule {
}
exports.MainModule = MainModule;
